import React, { Component } from 'react';
import { serverIp, firebaseAuth, logComponentLoad, } from '../../../../config/constants.js'
import { List, Button, Divider } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import axios from 'axios'
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';

function ActionSteps(props) {

    const listRow = props.actionStep.actions.map((action, index) =>

        <List.Item>{index}: {action}</List.Item>
    )

    return (
        <div>
            <List>
                {listRow}
            </List>
        </div>
    )
}

class ViewServerLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            loadingUser: true,
            loading: false,
            actionSteps: [],
            redis_List: [],
            serverUrl: ''
        }
    }

    componentDidMount() {

        if (this.props.match.params.server == 'local') {


            this.setState({
                serverUrl: "http://localhost:8080/PrintBReporting/webresources/"
            })

            console.log("server set to http://localhost:8080/PrintBReporting/webresources/");

        } else {
            this.setState({
                serverUrl: "https://printbaws.com/PrintBReporting/webresources/"
            })

            console.log("server set to https://printbaws.com/PrintBReporting/webresources/");
        }

        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewMessageLogs");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

        if (returnObject.isAdmin) {

            this.loadMessageLogs(this.props.match.params.messageId);

        }
    }

    loadMessageLogs = () => {
        // SEND CHECK TO SERVER

        this.setState({
            loadingUser: true
        })

        console.log("url:" + this.state.serverUrl + "redis/getLogs/" + this.props.match.params.methodName);

        axios.get(this.state.serverUrl + "redis/getLogs/" + this.props.match.params.methodName)
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                if (response.data.redis_List && response.data.redis_List.length > 0) {
                    console.log('got redis_List events');
                    this.setState({
                        redis_List: response.data.redis_List,
                        actionSteps: response.data.actionSteps
                    })
                } else {
                    alert("no message logs found for:" + this.props.match.params.methodName);
                    this.setState({
                        redis_List: []
                    })
                }

                this.setState({
                    loadingUser: false
                })

            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    deleteLogs = () => {
        // SEND CHECK TO SERVER

        this.setState({
            loadingUser: true
        })

        console.log("url:" + this.state.serverUrl + "redis/delete_redis_key");

        axios.post(this.state.serverUrl + "redis/delete_redis_key", {
            apiKey: "deleteLogs",
            redis_key: this.props.match.params.methodName
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");
                    alert("logs deleted");
                    this.loadMessageLogs();
                } else {
                    console.log("FAILED");
                    alert("FAILED TO delete");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const SentPart = (props) => props.actionStep.sent
            ? <div><pre>{JSON.stringify(props.actionStep.sent, null, 2)}</pre></div>
            : ''

        const listRow = this.state.actionSteps.length > 0
            ? this.state.actionSteps.map((item, index) =>
                <div>
                    {/* <h3>{index}: {item.transName}</h3> */}
                    <Divider horizontal>{index}: {item.transName}</Divider>
                    <SentPart actionStep={item}/>
                    <ActionSteps actionStep={item} />

                </div>
            )
            : ''

        // const listRow = this.state.redis_List.length > 0
        // ? this.state.redis_List.map((item, index) =>
        //     <List.Item>{index}: {item}</List.Item>
        // )
        // : ''


        // const listRow = this.state.redis_List.length > 0
        //     ? this.state.redis_List.map((item, index) =>
        //         <div><pre>{JSON.stringify(item, null, 2) }</pre></div>
        //     )
        //     : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>
                <h1>server url:{this.state.serverUrl}</h1>
                <h2>method:{this.props.match.params.methodName}</h2>
                <br />
                <Button color='red' onClick={this.deleteLogs}>CLEAR</Button>
                <Button color='blue' onClick={this.loadMessageLogs}>RELOAD</Button>
                {/* <List> */}
                {listRow}
                {/* </List> */}

            </div>
            : <h4>loading error a75</h4>

        return (this.state.loadingUser === true ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>
        )
    }
}

export default ViewServerLogs;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ViewLogs/ViewServerLogs.js